import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getServiceCategories = async () => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: "service-category/list",
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getSubserviceCategories = async () => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: "subservice-category/list",
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const uploadImage = async (payload) => {
  try {
    return await internalApi.postImage(
      { server: "api/v1/", path: "user/upload?folder=SERVICE_CATEGORY" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const addServiceCategory = async (payload) => {
  try {
    return await internalApi.post(
      { server: "api/v1/", path: "admin/create-service-category" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const addSubserviceCategory = async (payload) => {
  try {
    return await internalApi.post(
      { server: "api/v1/", path: "admin/create-subservice-category" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateServiceCategory = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/service-category/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateServices = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/update-services?serviceId=${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateSubserviceCategory = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/subservice-category/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getAllServices = async ({ pageNumber, pageSize }) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `service/admin/list?pageNumber=${pageNumber}&itemPerPage=${pageSize}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getLookupServices = async (id) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `service/lookup-by-businessId?businessId=${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getBusinessServices = async ({
  pageNumber,
  pageSize,
  businessId,
}) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/services?pageNumber=${pageNumber}&itemPerPage=${pageSize}&businessId=${businessId}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getSubServices = async ({ pageNumber, pageSize, parentId }) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `service/sub-services?itemPerPage=${pageSize}&pageNumber=${pageNumber}&parentId=${parentId}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getSubServicesCategory = async () => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `subservice-category/list`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteService = async (id) => {
  try {
    return await internalApi.delete({
      server: "api/v1/",
      path: `admin/delete-service/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateParentChildSubCategory = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/subservice-category/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const applyVariantQuantityLimit = async (id, applyLimit, restrictedOrderQuantity) => {
  try {
    const payload = {
      applyLimit,
      restrictedOrderQuantity: restrictedOrderQuantity ?? null,
    };

    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/apply-variant-quantity-limit/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message || 'An error occurred while applying the limit');
  }
};

export const updateCategoriesOrder = async (payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: "admin/service-category/order/update",
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateSubcategoriesOrder = async (payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: "admin/subservice-category/order/update",
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
